// extracted by mini-css-extract-plugin
export default {"container":"PesertaFormEdit_container__bh9Aq","card":"PesertaFormEdit_card__TMfk3","title":"PesertaFormEdit_title__uVS5s"};